// ─── /app/projects — la cartera de proyectos (ADR 0039, GHE #1200) ───
// Until slice 5 this path was a redirect alias to /app/clients, where the clients directory moved.
// It was a client-side router redirect, never an HTTP 301, so no browser cached it and the path is
// safe to reuse. A bookmark to the old "Proyectos" page now opens the portfolio.

import { createFileRoute } from '@tanstack/react-router';
import { ProjectPortfolioPage } from '../../features/projects/ProjectPortfolioPage';

export const Route = createFileRoute('/app/projects')({
  component: ProjectPortfolioPage,
});
